'use-strict';

import angular from 'angular';

export class LaunchService {
  constructor(
    $location,
    $route,
    $rootScope,
    $timeout,
    $http,
    localStorageService,
    loginService,
    notificationService,
    socketService,
    interfaceService,
    serviceWorker,
    browserStatisticsService,
  ) {
    'ngInject';

    this.$location = $location;
    this.$route = $route;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$http = $http;

    this.localStorageService = localStorageService;
    this.loginService = loginService;
    this.notificationService = notificationService;
    this.socketService = socketService;
    this.interfaceService = interfaceService;
    this.serviceWorker = serviceWorker;
    this.browserStatisticsService = browserStatisticsService;
  }

  /**
   * Constructor of app
   * Checks can be reauthenticated from previous refreshTokens
   * Fetches required data from API server
   */
  initializeAutoboard() {
    return new Promise((resolve) => {
      console.info('%c[Init]: Initialize Autoboard', 'background:#c59d3f;color:#fff');
      this.localStorageService.loadGlobalsFromLocalStorage()
        .then(() => {
          console.info('%c[Init]: Successfully initialized LocalStorage.', 'background:#c59d3f;color:#fff');
          return this.serviceWorker.initWorkbox();
        })
        .then(() => {
          console.info('%c[Init]: Successfully initialized Service Worker.', 'background:#c59d3f;color:#fff');
          this.browserStatisticsService.init();

          if (this.$location.path() === '/super-admin-login') this.loginService.superAdminLogin();
          return this.loginService.silentRefresh();
        })
        .then(() => {
          console.info('%c[Init]: Successfull silent refresh.', 'background:#c59d3f;color:#fff');
          return this.loginService.afterLogin();
        })
        .then(() => {
          console.info('%c[Init]: AfterLogin finished.', 'background:#c59d3f;color:#fff');
          this.$timeout(() => {
            this.$route.reload();
          }, 0);

          this.interfaceService.hidePagePreloader();
          if (this.$location.path() === '/super-admin-login') {
            this.$location.path('/');
            this.$location.search('token', null);
          }
          return resolve();
        })
        .catch(() => {
          this.interfaceService.hidePagePreloader();
          this.$location.path('/login');
          return resolve();
        });
    });
  }
}

export default angular.module('services.launchService', [])
  .service('launchService', LaunchService)
  .name;
